import React from 'react';
import styles from './page2.scss';
import pic1 from './1.png';
import pic2 from './2.png';
import pic3 from './3.png';
import pic4 from './4.png';
import pic5 from './5.png';
import pic6 from './6.png';
import { getRem } from '../../func';

function Page2(props) {
  return (
    <div className={styles['page2']} ref={props.myRef}>
      <div className={styles['page2-main']}>
        <div className={styles['page2-title']}>THE TEAM</div>

        <div className={styles['page2-subTitle']}>我们的团队</div>

        <div className={styles['page2-cardList']}>
          <div className={styles['page2-card']} style={{ marginRight: getRem(70) }}>
            <div className={styles['page2-card-pic']}>
              <img src={pic3} />
            </div>

            <div className={styles['page2-card-right']}>
              <div className={styles['page2-card-title2']}>
                <div className={styles.text}>李冰</div>
                <div className={styles.area} style={{ width: getRem(49) }} />
              </div>

              <div className={styles['page2-card-subTitle']}>
                WOW-TREND热点趋势 CEO/首席创意官<br />
                国内资深的趋势专家、品牌顾问和权威讲师
              </div>

              <div className={styles['page2-card-line']}></div>

              <div className={`${styles['page2-card-desc']} animate1-wrapper`}>
                <div r='244' g='248' b='255' className={`maskBlock animate1`} style={{ background: 'rgb(244, 248, 255)' }} />
                毕业于北京服装学院<br />
                Première Vision Paris面料展时尚趋势版块研究成员<br />
                唯品大学、香港时尚买手学院特邀趋势导师<br />
                浙江大学、中国美术学院纺织服装研究院客座教授<br />
                时尚经纬欧洲趋势讲师
              </div>
            </div>
          </div>

          <div className={styles['page2-card']} style={{ marginRight: getRem(70) }}>
            <div className={styles['page2-card-pic']}>
              <img src={pic1} />
            </div>

            <div className={styles['page2-card-right']}>
              <div className={styles['page2-card-title2']}>
                <div className={styles.text}>董薰（小王子）</div>
                <div className={styles.area} style={{ width: getRem(152) }} />
              </div>

              <div className={styles['page2-card-subTitle']}>
                WOW-TREND热点趋势<br />
                联合创始人/设计总监/首席工艺研发总监
              </div>

              <div className={styles['page2-card-line']}></div>

              <div className={`${styles['page2-card-desc']} animate1-wrapper`}>
                <div r='244' g='248' b='255' className={`maskBlock animate1`} style={{ background: 'rgb(244, 248, 255)' }} />
                行业资深工艺趋势专家<br />
                超15年女装产品开发和工艺趋势研究经验<br /><br />
                她还在艺术品投资上有自己独到的眼光，<br />
                是位艺术品收藏者。
              </div>
            </div>
          </div>

          <div className={styles['page2-card']}>
            <div className={styles['page2-card-pic']}>
              <img src={pic2} />
            </div>

            <div className={styles['page2-card-right']}>
              <div className={styles['page2-card-title1']}>
                <div className={styles.text}>文龙</div>
                <div className={styles.area} style={{ width: getRem(48) }} />
              </div>

              <div className={styles['page2-card-subTitle']}>
                WOW-TREND热点趋势<br />
                设计总监/男装趋势总监
              </div>

              <div className={styles['page2-card-line']}></div>

              <div className={`${styles['page2-card-desc']} animate1-wrapper`}>
                <div r='244' g='248' b='255' className={`maskBlock animate1`} style={{ background: 'rgb(244, 248, 255)' }} />
                服装行业资深趋势专家<br />
                超10年男装产品开发和工艺趋势研究经验
              </div>
            </div>
          </div>

          <div className={styles['page2-card']} style={{ marginRight: getRem(70) }}>
            <div className={styles['page2-card-pic']}>
              <img src={pic4} />
            </div>

            <div className={styles['page2-card-right']}>
              <div className={styles['page2-card-title2']}>
                <div className={styles.text}>刘婷（TINA）</div>
                <div className={styles.area} style={{ width: getRem(136) }} />
              </div>

              <div className={styles['page2-card-subTitle']}>
                WOW-TREND热点趋势<br />
                首席街拍趋势顾问
              </div>

              <div className={styles['page2-card-line']}></div>

              <div className={`${styles['page2-card-desc']} animate1-wrapper`}>
                <div r='244' g='248' b='255' className={`maskBlock animate1`} style={{ background: 'rgb(244, 248, 255)' }} />
                明星网红研究专家<br />
                街拍趋势高级讲师<br />
                四大时装周街拍资深研究员<br />
                全球消费者画像趋势研究专家<br />
                超10年国内外流行、细分市场风格<br />
                走向研究分析经验
              </div>
            </div>
          </div>

          <div className={styles['page2-card']} style={{ marginRight: getRem(70) }}>
            <div className={styles['page2-card-pic']}>
              <img src={pic5} />
            </div>

            <div className={styles['page2-card-right']}>
              <div className={styles['page2-card-title2']}>
                <div className={styles.text}>马蓉（教授）</div>
                <div className={styles.area} style={{ width: getRem(128) }} />
              </div>

              <div className={styles['page2-card-subTitle']}>
                WOW-TREND热点趋势<br />
                首席色彩趋势总监
              </div>

              <div className={styles['page2-card-line']}></div>

              <div className={`${styles['page2-card-desc']} animate1-wrapper`}>
                <div r='244' g='248' b='255' className={`maskBlock animate1`} style={{ background: 'rgb(244, 248, 255)' }} />
                国内资深趋势开发专家<br />
                服装行业资深色彩及面料顾问<br />
                [深圳时装周]流行趋势发布会特约讲师<br />
                [唯品会]唯品大学趋势课程特约讲师<br />
                教授喜欢观察生活中的色彩，<br />
                将灵感用画笔记录下来，还热衷收集旧物，<br />
                改造成独一无二的手工艺品。
              </div>
            </div>
          </div>

          <div className={styles['page2-card']}>
            <div className={styles['page2-card-pic']}>
              <img src={pic6} />
            </div>

            <div className={styles['page2-card-right']}>
              <div className={styles['page2-card-title2']}>
                <div className={styles.text}>许晓梦（MOMO）</div>
                <div className={styles.area} style={{ width: getRem(182) }} />
              </div>

              <div className={styles['page2-card-subTitle']}>
                WOW-TREND热点趋势<br />
                首席T台趋势总监
              </div>

              <div className={styles['page2-card-line']}></div>

              <div className={`${styles['page2-card-desc']} animate1-wrapper`}>
                <div r='244' g='248' b='255' className={`maskBlock animate1`} style={{ background: 'rgb(244, 248, 255)' }} />
                趋势高级讲师<br />
                四大时装周T台趋势研究员<br />
                国内外品牌发布会趋势研究专家<br />
                10年资深时装买手，<br />
                深度了解服装行业的研发、商品、零售模式。<br />
                除了秀场音乐，她还是一位ASMR爱好者，<br />
                声音能让她更集中并爆发创意力。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page2;